import * as z from "zod/v4";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum ProductTypeFilterQuery {
  CONTAINS = "contains",
  NOT_CONTAINS = "notContains",
}

const ProductTypeFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.PRODUCT_TYPE,
  ProductTypeFilterQuery,
  z.array(z.string()),
);
export const ProductTypeFilterSchema: z.ZodType<ProductTypeFilter> =
  ProductTypeFilterSchema_;
export interface ProductTypeFilter
  extends z.infer<typeof ProductTypeFilterSchema_> {}
